import { forwardRef } from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";

import {
  SCROLL_BAR_CLASS,
  SCROLL_BAR_DEFAULTS,
  SCROLL_BAR_ORIENTATION_CLASS_MAP,
  SCROLL_BAR_THUMB_CLASS,
  type TScrollBarElement,
  type TScrollBarProps,
} from "@/ui/components/primitives/ScrollArea/ScrollArea.config";
import { cn } from "@/ui/lib/utils";

export const ScrollBar = forwardRef<TScrollBarElement, TScrollBarProps>(
  (
    {
      className,
      orientation = SCROLL_BAR_DEFAULTS.orientation,
      ...props
    },
    ref,
  ) => (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      ref={ref}
      data-component="ScrollBar"
      orientation={orientation}
      className={cn(
        SCROLL_BAR_CLASS,
        SCROLL_BAR_ORIENTATION_CLASS_MAP[orientation],
        className,
      )}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb
        data-component="ScrollBarThumb"
        className={SCROLL_BAR_THUMB_CLASS}
      />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  ),
);

ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
